document.addEventListener('DOMContentLoaded', function () {
  localStorage.setItem('announcementClosed', 'false');
  const announcementBar = document.querySelector('.announcement-bar-section');
  const closeButton = document.getElementById('AnnouncementClose');
  if (
    localStorage.getItem('announcementClosed') === 'true' ||
    (localStorage.getItem('announcementClosed') === 'false' && window.location.pathname.includes('/account'))
  ) {
    announcementBar.classList.add('hidden');
    document.body.classList.add('hide-announcement');
  }

  closeButton.addEventListener('click', function () {
    announcementBar.classList.add('hidden');
    document.body.classList.add('hide-announcement');
    localStorage.setItem('announcementClosed', 'true');
  });

  document.querySelectorAll('.announcement-bar__link-klaviyo').forEach(function (element) {
    element.addEventListener('click', function () {
      const klaviyoFormId = this.getAttribute('data-klaviyo-form');
      if (klaviyoFormId) {
        window.klaviyo.push(['openForm', klaviyoFormId]);
      }
    });
  });
});
